(() => {
  if (customElements.get('niaash-cart-preview')) return;
  class CartPreview extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const image = new Image();
      image.onload = () => {
        if (!this.isConnected) return;
        const dim = window.NiaashPrintMath.dimensions(image.naturalWidth, image.naturalHeight, this.dataset.width ? Number(this.dataset.width) : 18 * Math.min(1, image.naturalWidth / image.naturalHeight));
        if (!dim) return;
        const tiles = window.NiaashPrintMath.tiles(dim.width, dim.height, this.dataset.mode);
        if (!tiles.length) return;
        const canvas = this.querySelector('canvas'), ctx = canvas.getContext('2d'), factor = canvas.width / 50;
        ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
        tiles.forEach(t => { ctx.save(); ctx.translate((t.x + (t.flipX ? dim.width : 0)) * factor, (t.y + (t.flipY ? dim.height : 0)) * factor); ctx.scale(t.flipX ? -1 : 1, t.flipY ? -1 : 1); ctx.drawImage(image, 0, 0, dim.width * factor, dim.height * factor); ctx.restore(); });
        this.hidden = false;
      };
      image.src = this.dataset.source;
    }
  }
  customElements.define('niaash-cart-preview', CartPreview);
})();
